export default "__VITE_ASSET__BM5Da54Y__"